import { useMutation, useQueryClient } from '@tanstack/react-query';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface DeleteProvidedDocumentProps {
  declarationId: string;
  documentId: string;
}

export const useDeleteProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, documentId }: DeleteProvidedDocumentProps) => {
      const result = await apiClient.declarationsDocuments.deleteProvidedDocument.mutation({
        params: { id: declarationId, documentId },
      });

      if (result.status !== 200) throw result.body;

      return result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting document!');
    },
  });
};
